import { createContext, FC, ReactNode, useContext, useState } from 'react';

type UserContextType = {
  env: string | null;
  maintenance: boolean;
  setEnvironment: (env: string | null) => void;
  setUnderMaintenance: (mode: boolean) => void;
};

const ApplicationContext = createContext<UserContextType | undefined>(undefined);

const ApplicationProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [env, setEnv] = useState<string | null>(null);
  const [maintenance, setMaintenance] = useState<boolean>(false);

  const setEnvironment = (env: string | null) => {
    setEnv(env);
  };

  const setUnderMaintenance = (mode: boolean) => {
    setMaintenance(mode);
  };

  return (
    <ApplicationContext.Provider
      value={{
        env,
        maintenance,
        setEnvironment,
        setUnderMaintenance,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export default ApplicationProvider;

export const useApplicationContext = () => {
  const context = useContext(ApplicationContext);

  if (!context) {
    throw new Error('useApplicationContext must be used within a ApplicationProvider');
  }
  return context;
};
